import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const deleteKbArticle = createAsyncThunk(
    'kbActions/deleteKbArticle',
    async ({ articleIds, group_id }, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;

            const url = `${ROOT_URL}/kb/articles`; // URL changed to remove /:id

            // Axios DELETE accepts body in 'data' property of the config object
            const response = await axios.delete(url, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                },
                data: { articleIds, group_id }
            });
            return { articleIds, message: response.data.message };
        } catch (error) {
            console.error('Error deleting article:', error);
            return rejectWithValue(
                error.response?.data?.message || 'Failed to delete article'
            );
        }
    }
);

export const archiveKbArticle = createAsyncThunk(
    'kbActions/archiveKbArticle',
    async ({ articleId, group_id }, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;

            const url = `${ROOT_URL}/kb/articles/${articleId}/archive`;

            const response = await axios.patch(url, { group_id }, {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });
            return { articleId, message: response.data.message };
        } catch (error) {
            console.error('Error archiving article:', error);
            return rejectWithValue(
                error.response?.data?.message || 'Failed to archive article'
            );
        }
    }
);


const initialState = {
    actionLoading: false,
    error: null,
    successMessage: null,
};

const kbActionsSlice = createSlice({
    name: 'kbActions',
    initialState,
    reducers: {
        clearActionState: (state) => {
            state.actionLoading = false;
            state.error = null;
            state.successMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(deleteKbArticle.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(deleteKbArticle.fulfilled, (state, action) => {
                state.actionLoading = false;
                state.successMessage = action.payload.message;
            })
            .addCase(deleteKbArticle.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            })
            .addCase(archiveKbArticle.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(archiveKbArticle.fulfilled, (state, action) => {
                state.actionLoading = false;
                state.successMessage = action.payload.message;
            })
            .addCase(archiveKbArticle.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            });
    }
});

export const { clearActionState } = kbActionsSlice.actions;
export default kbActionsSlice.reducer;
